import { Moon, Sun, Monitor } from 'lucide-react';
import { Theme, useTheme } from '../contexts/ThemeContext';
const choices: {value: Theme; label: string; icon: typeof Sun}[] = [
  {value:'light',label:'Claro',icon:Sun},
  {value:'dark',label:'Oscuro',icon:Moon},
  {value:'system',label:'Sistema',icon:Monitor},
];
export default function ThemeSelect() {
  const {theme,setTheme} = useTheme();
  return <div role="group" aria-label="Tema de apariencia" className="ml-auto flex shrink-0 items-center gap-0.5">
    {choices.map(({value,label,icon:Icon}) => <button key={value} type="button" aria-label={label} title={label} aria-pressed={theme === value} onClick={()=>setTheme(value)}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-md transition-colors motion-reduce:transition-none focus-visible:outline-blue-600 ${theme === value ? 'bg-slate-100 text-blue-700' : 'text-slate-500 hover:bg-slate-100 hover:text-slate-900'}`}>
      <Icon aria-hidden="true" className="h-4 w-4" />
    </button>)}
  </div>;
}
